export default __webpack_public_path__ + "media/images/ic-cost-1-3b5a70f2408727ae565b7189e23efe69.png";